/** Modules, plans, organization settings and the audit trail. */
import { api } from '../lib/apiClient.js';

// --- catalog ---------------------------------------------------------------

export const listModules = (query) => api.get('/platform/modules', { query, skipTenant: true });
export const listPlans = () => api.get('/platform/plans', { skipTenant: true });

// --- per-organization ------------------------------------------------------

export const getSettings = (tenantId) => api.get(`/platform/tenants/${tenantId}/settings`);

/**
 * The localization subset of the settings (currency, timezone, formats,
 * language, tax) — readable by every member, whatever their role.
 */
export const getLocalization = (tenantId) => api.get(`/platform/tenants/${tenantId}/localization`);

/** Countries, presets, tax systems and formats; the same for every organization. */
export const localizationCatalog = () => api.get('/platform/localization/catalog', { skipTenant: true });

export const updateSettings = (tenantId, payload) => api.put(`/platform/tenants/${tenantId}/settings`, payload);

/** The catalog, flagged with what this organization has enabled. */
export const tenantModules = (tenantId) => api.get(`/platform/tenants/${tenantId}/modules`);

export const enableModule = (tenantId, moduleId) =>
  api.post(`/platform/tenants/${tenantId}/modules/${moduleId}/enable`);

export const disableModule = (tenantId, moduleId) =>
  api.post(`/platform/tenants/${tenantId}/modules/${moduleId}/disable`);

// Switching an optional module ON is approved by a platform administrator:
// anyone in the organization asks, the administrator decides in ERP-ADMIN.
// (`enableModule` above is for platform administrators only.)

export const requestModule = (tenantId, moduleId, note) =>
  api.post(`/platform/tenants/${tenantId}/modules/${moduleId}/request`, note ? { note } : {});

/** This organization's requests, newest first, with who asked and who decided. */
export const moduleRequests = (tenantId) => api.get(`/platform/tenants/${tenantId}/module-requests`);

export const withdrawModuleRequest = (tenantId, requestId) =>
  api.post(`/platform/tenants/${tenantId}/module-requests/${requestId}/withdraw`);

// --- audit trail -----------------------------------------------------------
// Both reads take `scope`: 'mine' (your own activity; any member) or 'all'
// (everyone's; needs audit.read, as does a `userId` other than your own).

export const listAuditLogs = (tenantId, query, options) =>
  api.list(`/platform/tenants/${tenantId}/audit-logs`, query, options);

/** Cursor-paginated feed for the dashboard. Cheaper than the offset list. */
export const auditFeed = (tenantId, query, options) =>
  api.list(`/platform/tenants/${tenantId}/audit-logs/feed`, query, options);

/** Everyone with activity here, for the log's person filter. Needs audit.read. */
export const auditActors = (tenantId) => api.get(`/platform/tenants/${tenantId}/audit-logs/actors`);

/** The history of one record, for a document's activity tab. */
export const auditForEntity = (tenantId, entity, entityId) =>
  api.get(`/platform/tenants/${tenantId}/audit-logs/entity`, { query: { entity, entityId } });
